// import { KTCard } from '../../../../_metronic/helpers'
// import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
// import { Link } from 'react-router-dom'
// import clsx from 'clsx'
// import React from 'react'
// import { useAuth } from '../../auth'


// const allFeatures = [
//   { name: 'Material Inward', icon: 'collect', to: 'collect-orders' },
//   { name: 'Processing', icon: 'proessing', to: 'processing-record' },
//   { name: 'Lab Mgmt', icon: 'proessing', to: 'lab-mgmt' }, // this
//   { name: 'Test Certificates', icon: 'testing', to: 'test-certificate' },// this
//   { name: 'External Sale', icon: 'external sale', to: 'items' },
//   { name: 'Material Transfer', icon: 'Material transfer', to: 'supply-orders' },
//   { name: 'Purchase Order', icon: 'purchase order', to: 'purchase-orders' },// this
// ]

// const Menu = () => {
//   const { currentUser, isSupplyChainManager, auth }: any = useAuth()
//   console.log("currentUser is", currentUser.userType)
//   const features = allFeatures.filter(feature => {
//     if (feature.name === 'Test Certifiactes') {
//       return currentUser?.userType === 'PICKUP_POINT_STAFF' || currentUser?.userType === 'FRANCHISE_USER'
//     }
//     return true
//   })
//   return (
//     <KTCard addCard={false}>
//       <div className='row g-xl-4'>
//         {features.map((eachFeatures, eachIndex) => (
//           <div key={eachIndex + 1 + ''} className='col col-lg-2'>
//             <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
//               <Card4
//                 // icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 icon={`/media/svg/files/${eachFeatures.icon}.png`}
//                 title={eachFeatures.name}
//                 description=''
//               />
//             </Link>
//           </div>
//         ))}
//       </div>
//     </KTCard>
//   )
// }

// const TransactionsMenu = () => <Menu />

// export { TransactionsMenu }




import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'
import { useFetchCommon } from '../../../../_metronic/helpers/crud-helper/useQuery'

const allFeatures = [
  { name: 'Material inward', icon: 'FTS Material Inward', to: 'collect-orders' },
  { name: 'Processing', icon: 'Processing', to: 'processing-record' },
  // { name: 'Lab Mgmt', icon: 'testing', to: 'lab-mgmt' },
  // { name: 'Test Certificates', icon: 'testCer', to: 'test-certificate' },
  { name: 'Material transfer', icon: 'FTS Material transfer', to: 'supply-orders' },
  { name: 'External sale', icon: 'external sale', to: 'items' },
  // { name: 'Working Stock', icon: 'working stock', to: 'working-stock' },
  // { name: 'Bag Tags', icon: 'bag tag', to: 'working-stock' },
  { name: 'Receive shipment', icon: 'collect', to: 'shipment' },
  { name: 'Log production', icon: 'Log Production', to: 'operation' },
  // { name: 'Purchase Order', icon: 'purchase order', to: 'purchase-orders' },
]

const Menu = () => {
  const { currentUser, isSupplyChainManager, auth }: any = useAuth()
  console.log("currentUser is", currentUser.userType)

  const [franchiseId, setFranchiseId] = React.useState('')
  React.useEffect(() => {
    const authData = localStorage.getItem('kt-auth-react-v')
    if (authData) {
      try {
        const parsedData = JSON.parse(authData)
        const userIdFromStorage = parsedData?.data?.userId || ''
        const franchiseIdFromStorage = parsedData?.data?.franchiseId || ''

        // setUserId(userIdFromStorage)
        setFranchiseId(franchiseIdFromStorage)

        console.log('UserId from localStorage:', userIdFromStorage)
        console.log('FranchiseId from localStorage:', franchiseIdFromStorage)
      } catch (error) {
        console.error('Error parsing auth data:', error)
      }
    }
  }, [])

  const { responseData: franchiseData, isFetching: isFetchingFranchise } = useFetchCommon({
    api: `users/${franchiseId}`,
    isDropDown: false,
    isEnabled: !!franchiseId,
  })

  const features = allFeatures.filter(feature => {
    // Hide specific features for CLIENT users
    if (currentUser?.userType === 'CLIENT') {
      const hiddenFeatures = ['Lab Mgmt', 'Test Certificates', 'Purchase Order']
      if (hiddenFeatures.includes(feature.name)) {
        return false
      }
    }

    // if (feature.name === 'Working Stock' || feature.name === 'Bag Tags') {
    //   return currentUser?.userType === 'PICKUP_POINT_STAFF'
    // }
    if ((feature.name === 'Working Stock' || feature.name === 'Bag Tags')) {
      return (
        currentUser?.userType === 'PICKUP_POINT_STAFF' &&
        franchiseData?.customSettings?.preferences?.batchManagement === 'MANUAL'
      )
    }


    // Existing filter logic
    if (feature.name === 'Test Certificates') {
      return currentUser?.userType === 'PICKUP_POINT_STAFF' || currentUser?.userType === 'FRANCHISE_USER'
    }

    if (feature.name === 'Receive shipment') {
      return currentUser?.userType === 'PICKUP_POINT_STAFF'
    }

    return true
  })


  return (
    <KTCard addCard={false}>
      <div className='row g-xl-4'>
        {features.map((eachFeatures, eachIndex) => (
          <div key={eachIndex + 1 + ''} className='col col-lg-2'>
            <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
              <Card4
                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                title={eachFeatures.name}
                description=''
              />
            </Link>
          </div>
        ))}
      </div>
    </KTCard>
  )
}

const TransactionsMenu = () => <Menu />
export { TransactionsMenu }